module.exports = __webpack_public_path__ + "img/Elhassani.0f77fdaa.png";